import React, { useState } from 'react';

import ExpenseLibraryTemplatesEditForm from './ExpenseLibraryTemplatesEditForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ExpenseLibraryTemplatesEditModal(props) {
    const [templateIsUpdated, setTemplateIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setTemplateIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={props.upsertedTemplate?.id ? $t('Edit Template') : $t('Add New Template')} close={internalCloseHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.upsertedTemplate !== undefined && (
                            <div className="modal__form-container">
                                <div className={!templateIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                    <ExpenseLibraryTemplatesEditForm
                                        internalCloseHandler={internalCloseHandler}
                                        template={props.upsertedTemplate}
                                        templatesCreateUrl={props.templatesCreateUrl}
                                        templatesStoreUrl={props.templatesStoreUrl}
                                        templatesUpdateUrl={props.templatesUpdateUrl}
                                        setTemplateIsUpdated={setTemplateIsUpdated}
                                        request={request}
                                    />
                                </div>
                                <div className={templateIsUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                    <label className="modal__msg modal__text-color">{$t('{{name}} updated', { name: props.upsertedTemplate?.name })}</label>
                                </div>
                                <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                    <label className="modal__msg modal__error-text-color">
                                        {$t('{{name}} could not be updated', { name: props.upsertedTemplate?.name })}
                                    </label>
                                </div>

                                {(templateIsUpdated || requestFailed) && (
                                    <div className="modal__footer">
                                        <Button variant="secondary" onClick={internalSuccessHandler}>
                                            {$t('Close')}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
